import Dashboard from "views/Dashboard/Dashboard.js";
import DashboardIcon from "@material-ui/icons/Dashboard";
import userManagement from "views/Pages/userManagement";
import ManageLotteries from "views/Pages/ManageLotteries";
import ManageNotificationTemplate from "views/Pages/ManageNotification.js";
import ContactUs from "views/Pages/ContactUs";
import ManagePromotion from "views/Pages/ManagePromotion";
import KYCVerificationManagement from "views/Pages/KYCVerificationManagement";
import EnquiryLogs from "views/Pages/EnquiryLogs";
import SoldTickets from "views/Pages/soldTicketsLog";
import WinnerLogs from "views/Pages/WinnerLogs";
import AboutUs from "views/Pages/AboutUsUpdate";
import Rules from "views/Pages/rules";
import Licensing from "views/Pages/licensing";
import TermsOfUse from "views/Pages/termsOfUse";
import PrivacyNotice from "views/Pages/privacyNotice";
import Donations from "views/Pages/donations";
import transactionLog from "views/Pages/transactionLog";
import ManageICOPage from "views/Pages/ManageICOPage";
import ManageRoles from "views/Pages/ManageRoles";
import AddRoles from "views/Pages/AddRoles";
import ManagePayout from "views/Pages/ManagePayout";
import ManageWithdrawalMethods from "views/Pages/ManageWithdrawalMethods";
import FAQ from "views/Pages/faq";
import NotificationLog from "views/Pages/NotificationLog";
import ManageWithdraw from "views/Pages/ManageWithdraw";
import {
  AccountBalanceOutlined,
  EmailOutlined,
  LocalActivityOutlined,
  LocalAtmOutlined,
  PeopleOutline,
  PersonOutline,
  NotificationImportantOutlined,
  CheckBoxSharp,
  PagesOutlined,
  ReportOutlined
} from "@material-ui/icons";
import CasinoIcon from "@material-ui/icons/Casino";
import BannerHomePage from "views/Pages/bannerHomePage";
import TransferPrivateInvestors from "views/Pages/TransferPrivateInvestors";
import ChangePublicAdmin from "views/Pages/ChangePublicAdmin";
import ManageJackpot from "views/Pages/jackpotManagement";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import CreateLottery from "views/Pages/CreateLottery";
import AddUser from "views/Pages/addUser";
import AddAdmin from "views/Pages/addAdmin";
import EditUser from "views/Pages/editUser";
import UserTransactionList from "views/Pages/UserTransactionList";
import EditAdmin from "views/Pages/editAdmin";
import ViewLottery from "views/Pages/viewLottery";
import EditLottery from "views/Pages/editLottery";
import AdminManagement from "views/Pages/adminManagement";
import AddPromotionsBuy from "views/Pages/AddPromotionsBuy";
import AddPromotionsUser from "views/Pages/AddPromotionsUser";
import WinnerLogsTable from "views/Pages/winnerLogsTable";
import SoldTicketsTable from "views/Pages/soldTicketsTable";
import SendNotification from "views/Pages/SendNotification";
import AddFAQ from "views/Pages/addFaq";
import CommunityPromotion from "views/Pages/communityPromotions";
var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: DashboardIcon,
    component: Dashboard,
    layout: "/admin"
  },
  {
    path: "/userManagement",
    name: "Manage User",
    rtlName: "عالتسعير",
    icon: AccountBalanceOutlined,
    component: userManagement,
    layout: "/admin",
    children: [
      {
        path: "addUser",
        name: "Add User",
        component: AddUser,
        layout: "/admin"
      },
      {
        path: "addAdmin",
        name: "Add Admin",
        component: AddAdmin,
        layout: "/admin"
      },
      {
        path: "editUser",
        name: "Edit User",
        component: EditUser,
        layout: "/admin"
      },

      {
        path: "viewUser",
        name: "View User",
        component: UserTransactionList,
        layout: "/admin"
      },
      {
        path: "viewAdmin",
        name: "View Admin",
        component: AdminManagement,
        layout: "/admin",
        children: [
          {
            path: "editAdmin",
            name: "Edit Admin",
            component: EditAdmin,
            layout: "/admin"
          }
        ]
      }
    ]
  },
  {
    path: "/ManageLotteries",
    name: "Lottery Management",
    icon: LocalAtmOutlined,
    component: ManageLotteries,
    layout: "/admin",
    children: [
      {
        path: "createLottery",
        name: "Create Lottery",
        component: CreateLottery,
        layout: "/admin"
      },
      {
        path: "editLottery/:lotteryId",
        name: "Edit lottery",
        component: EditLottery,
        layout: "/admin"
      },
      {
        path: "viewLottery/:lotteryId",
        name: "View lottery",
        component: ViewLottery,
        layout: "/admin"
      }
    ]
  },

  {
    path: "/ManageJackpot",
    name: "Jackpot Management",
    rtlName: "صفحات",
    icon: CasinoIcon,
    component: ManageJackpot,
    layout: "/admin"
  },

  {
    icon: LocalActivityOutlined,
    path: "/ManagePayout",
    name: "Manage Payout",
    rtlName: "عالتسعير",
    mini: "ML",
    rtlMini: "ع",
    component: ManagePayout,
    layout: "/admin"
  },

  {
    path: "/ManageKYC",
    name: "KYC Verification",
    rtlName: "عالتسعير",
    icon: PeopleOutline,
    component: KYCVerificationManagement,
    layout: "/admin"
  },

  {
    icon: PersonOutline,
    path: "/ManageWithdraw",
    name: "Manage Withdrawals",
    rtlName: "عالتسعير",
    mini: "MP",
    rtlMini: "ع",
    component: ManageWithdraw,
    layout: "/admin"
  },

  // {
  //   icon: EmailOutlined,
  //   path: "/manageWithdrawalMethods",
  //   name: "Payment Management",
  //   rtlName: "عالتسعير",
  //   mini: "MP",
  //   rtlMini: "ع",
  //   component: ManageWithdrawalMethods,
  //   layout: "/admin"
  // },

  {
    collapse: true,
    path: "/report-management",
    name: "Report Management",
    rtlName: "صفحات",
    icon: ReportOutlined,
    state: "pageCollapse6",
    layout: "/admin",
    views: [
      {
        path: "/report-management/transactionLogs",
        name: "Transaction Logs",
        rtlName: "عالتسعير",
        mini: "TL",
        rtlMini: "ع",
        component: transactionLog,
        layout: "/admin"
      },
      {
        path: "/report-management/WinnerLogs",
        name: "Winner Logs",
        rtlName: "عالتسعير",
        mini: "WL",
        rtlMini: "ع",
        component: WinnerLogs,
        layout: "/admin",
        children: [
          {
            path: "winnerLogsById",
            name: "Transaction Logs",
            component: WinnerLogsTable,
            layout: "/admin"
          }
        ]
      },
      {
        path: "/report-management/soldTicketLogs",
        name: "Sold Ticket Logs",
        rtlName: "عالتسعير",
        mini: "STL",
        rtlMini: "ع",
        component: SoldTickets,
        layout: "/admin",
        children: [
          {
            path: "soldTicketLogsById",
            name: "Sold Ticket Logs",
            component: SoldTicketsTable,
            layout: "/admin"
          }
        ]
      },
      {
        path: "/report-management/notificationHistory",
        name: "Notification History",
        rtlName: "عالتسعير",
        mini: "NH",
        rtlMini: "ع",
        component: NotificationLog,
        layout: "/admin"
      },
      {
        path: "/report-management/enquiryLogs",
        name: "Enquiry Logs",
        rtlName: "عالتسعير",
        mini: "EL",
        rtlMini: "ع",
        component: EnquiryLogs,
        layout: "/admin"
      }
    ]
  },

  {
    path: "/ManagePromotion",
    icon: PriceCheckIcon,
    name: "Manage Promotion",
    component: ManagePromotion,
    layout: "/admin",
    children: [
      {
        path: "editPromotions/BuyTicket/:id",
        name: "add promotions",
        component: AddPromotionsBuy,
        layout: "/admin"
      },
      {
        path: "editPromotions/UserRegistration/:id",
        name: "add promotions",
        rtlName: "عالتسعير",
        mini: "MA",
        rtlMini: "ع",
        component: AddPromotionsUser,
        layout: "/admin"
      },
      {
        path: "createPromotion/BuyTicket",
        name: "add promotions",
        rtlName: "عالتسعير",
        mini: "MA",
        rtlMini: "ع",
        component: AddPromotionsBuy,
        layout: "/admin"
      },
      {
        path: "createPromotion/UserRegistration",
        name: "add promotions",
        rtlName: "عالتسعير",
        mini: "MA",
        rtlMini: "ع",
        component: AddPromotionsUser,
        layout: "/admin"
      },
      {
        path: "createPromotion/CommunityPromotions",
        name: "add promotions",
        rtlName: "عالتسعير",
        mini: "MA",
        rtlMini: "ع",
        component: CommunityPromotion,
        layout: "/admin"
      },
      {
        path: "editPromotions/CommunityPromotions/:id",
        name: "add promotions",
        rtlName: "عالتسعير",
        mini: "MA",
        rtlMini: "ع",
        component: CommunityPromotion,
        layout: "/admin"
      },
    ]
  },

  {
    collapse: true,
    name: "Manage Pages",
    path: "/manage-pages",
    rtlName: "صفحات",
    icon: PagesOutlined,
    state: "pageCollapse2",
    layout: "/admin",
    views: [
      {
        path: "/manage-pages/contactUs",
        name: "Contact Us",
        rtlName: "عالتسعير",
        mini: "CU",
        rtlMini: "ع",
        component: ContactUs,
        layout: "/admin"
      },
      {
        path: "/manage-pages/aboutUs",
        name: "About Us",
        rtlName: "عالتسعير",
        mini: "AU",
        rtlMini: "ع",
        component: AboutUs,
        layout: "/admin"
      },
      {
        path: "/manage-pages/rules",
        name: "Rules",
        rtlName: "عالتسعير",
        mini: "R",
        rtlMini: "ع",
        component: Rules,
        layout: "/admin"
      },
      {
        path: "/manage-pages/licensing",
        name: "Licensing",
        rtlName: "عالتسعير",
        mini: "L",
        rtlMini: "ع",
        component: Licensing,
        layout: "/admin"
      },
      {
        path: "/manage-pages/terms-of-use",
        name: "Terms of Use",
        rtlName: "عالتسعير",
        mini: "ToU",
        rtlMini: "ع",
        component: TermsOfUse,
        layout: "/admin"
      },
      {
        path: "/manage-pages/privacyNotice",
        name: "Privacy Notice",
        rtlName: "عالتسعير",
        mini: "PN",
        rtlMini: "ع",
        component: PrivacyNotice,
        layout: "/admin"
      },
      {
        path: "/manage-pages/donation",
        name: "Donations",
        rtlName: "عالتسعير",
        mini: "D",
        rtlMini: "ع",
        component: Donations,
        layout: "/admin"
      },
      {
        path: "/manage-pages/faq",
        name: "FAQs",
        rtlName: "عالتسعير",
        mini: "FaQ",
        rtlMini: "ع",
        component: FAQ,
        layout: "/admin",
        children: [
          {
            path: "addFAQ",
            name: "Add Faq",
            rtlName: "عالتسعير",
            mini: "AF",
            rtlMini: "ع",
            component: AddFAQ,
            layout: "/admin",
          },
        ]
      },
      {
        path: "/manage-pages/bannerHomePage",
        name: "Banner Home Page",
        rtlName: "عالتسعير",
        mini: "BHP",
        rtlMini: "ع",
        component: BannerHomePage,
        layout: "/admin"
      },
      // {
      //   path: "/manage-pages/manageIcoPage",
      //   name: "Manage ICO Page",
      //   rtlName: "عالتسعير",
      //   mini: "MIO",
      //   rtlMini: "ع",
      //   component: ManageICOPage,
      //   layout: "/admin"
      // },
      // {
      //   path: "/manage-pages/publicTransfer",
      //   name: "Public Coin Transfer",
      //   rtlName: "عالتسعير",
      //   mini: "MIO",
      //   rtlMini: "ع",
      //   component: TransferPrivateInvestors,
      //   layout: "/admin"
      // },
      // {
      //   path: "/manage-pages/changeAdmin",
      //   name: "Change Public Admin",
      //   rtlName: "عالتسعير",
      //   mini: "MIO",
      //   rtlMini: "ع",
      //   component: ChangePublicAdmin,
      //   layout: "/admin"
      // }
    ]
  },
  {
    path: "/roles-permissions",
    icon: CheckBoxSharp,
    name: "Roles & Permission",
    rtlName: "عالتسعير",
    mini: "MP",
    rtlMini: "ع",
    component: ManageRoles,
    layout: "/admin"
  },

  {
    icon: NotificationImportantOutlined,
    path: "/ManageNotificationTemplate",
    name: "Notification Management",
    rtlName: "عالتسعير",
    mini: "MNT",
    rtlMini: "ع",
    component: ManageNotificationTemplate,
    layout: "/admin",
    children: [
      {
        path: "send-notification",
        name: "send notification",
        component: SendNotification,
        layout: "/admin"
      }
    ]
  },

];
export default dashRoutes;
